import { sharedEn } from '@workspace/ui';

const en = {
  ...sharedEn,
} as const;

export default en;
